import React, { useEffect, useState, useCallback } from "react";
import { useLiff } from "react-liff";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import TopBanner from '../../components/layout/TopBanner';
import rewardBtn from "../../assets/images/reward-btn.svg";
import myCouponBtn from "../../assets/images/my-coupon-btn.svg";
import coupon1 from '../../assets/images/coupon1.png';
import InfiniteScroll from 'react-infinite-scroller';
import InputAdornment from '@mui/material/InputAdornment';
import Search from '@mui/icons-material/Search';
import coupon2 from '../../assets/images/coupon2.png';
import FilterListIcon from '@mui/icons-material/FilterList';
import PrimaryButtonSmall from "../../components/button/PrimaryButtonSmall";
import SecondaryButtonSmall from "../../components/button/SecondaryButtonSmall";
import PrimaryButton from "../../components/button/PrimaryButton";
import SecondaryButton from "../../components/button/SecondaryButton";
import RedButtonSmall from "../../components/button/RedButtonSmall";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import helper from "../../functions/helper";
import { SearchMyCoupon, InsertCoupon, SearchMyCouponOnline, SearchCouponHistory } from "../../services/Coupon";
import { useDispatch, useSelector } from 'react-redux';
import { Dialog } from "@mui/material";
import CircleExit from "../../assets/images/icon/CircleExit";
import { setMember } from "../../features/MemberSlice";
import { Controller, useForm } from "react-hook-form";

import { Autocomplete, TextField } from "@mui/material";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { SearchDdlAddress2 } from "../../services/Dropdown";
import TopBtn from "../../components/layout/TopBtnMember";
import { setLoading } from "../../features/LoadingSlice";
import { SearchMemberProfile } from "../../services/Member";
import TransparentButton from "../../components/button/TransparentButton";
import backgroundSuccess from '../../assets/images/register/bg-success.png';

let timer = null

export default function MemberCouponMain() {

  const initialLoadMore = {
    limit: 3,
    offset: 0,
  }

  const txt = {
    require: "กรุณากรอก",
    province: "จังหวัด",
    amphoe: "เขต/อำเภอ",
    tambol: "แขวง/ตำบล",
    zipCode: "รหัสไปรษณีย์",
  };

  const { register, formState: { errors }, handleSubmit, getValues, setValue, control, watch } = useForm({
    defaultValues: {
      amphoeId: null,
      provinceId: null,
    }
  });


  const [storeCouponList, setStoreCouponList] = React.useState([]);
  const [onlineCouponList, setOnlineCouponList] = React.useState([]);
  const [historyList, setHistoryList] = React.useState([]);

  const [openCookiePopup, setOpenCookiePopup] = React.useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isStoreCouponActive, setIsStoreCouponActive] = React.useState(true);
  const [isOnlineCouponActive, setIsOnlineCouponActive] = React.useState(false);
  const [isHistoryActive, setIsHistoryActive] = React.useState(false);

  const [filterStoreCoupon, setFilterStoreCoupon] = React.useState(1);
  const [filterAmphoe, setFilterAmphoe] = React.useState(null);
  const [filterProvince, setFilterProvince] = React.useState(null);
  const [filterName, setFilterName] = React.useState(null);

  const [isSelectStoreCoupon, setIsSelectStoreCoupon] = React.useState(1);

  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  const [memberId, setMemberId] = useState(null);
  const [loadMore, setLoadmore] = React.useState(initialLoadMore);
  const [loadMoreOnline, setLoadMoreOnline] = React.useState(initialLoadMore);
  const [loadMoreHistory, setLoadMoreHistory] = React.useState(initialLoadMore);
  const [nextPage, setNextPage] = useState(false)

  const [provinceList, setProvinceList] = React.useState([]);
  const [amphoeList, setAmphoeList] = React.useState([]);
  const [amphoe, setAmphoe] = React.useState(null);
  const [province, setProvince] = React.useState(null);
  const [amphoeId, setAmphoeId] = React.useState(null);
  const [provinceId, setProvinceId] = React.useState(null);


  const [openAmphoe, setOpenAmphoe] = React.useState(false);
  const [openProvince, setOpenProvince] = React.useState(false);
  const [delayId, setDelayId] = React.useState(null);

  const [fetching, setFetching] = useState(false);
  const [isDataNotFound, setIsDataNotFound] = React.useState(false);
  const [isChangeTab, setIsChangeTab] = React.useState(false);
  const [isChangeFilter, setIsChangeFilter] = React.useState(false);


  React.useEffect(() => {
    fnSetData('qrCode', null)
    getSearchMemberProfile()
  }, []);

  async function getSearchMemberProfile() {
    return await SearchMemberProfile({ lineId })
      .then(async (response) => {
        if (+response.data.resultCode !== 20000) {
          navigate("/register");
        } else {
          setMemberId(response.data.body.id)
          fnSetData('memberId', response.data.body.id)
          setNextPage(true)
          // getSearchMyCoupon()
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getSearchMyCoupon() {
    const { offset, limit } = loadMore
    let payload = {
      memberId: memberId,
      limit: limit,
      offset: offset,
      sort: filterStoreCoupon,
    }

    console.log(amphoe)
    if (amphoe) {
      payload.districtId = amphoeId
    }
    if (provinceId) {
      payload.provinceId = provinceId
    }

    if (filterName) {
      payload.name = filterName
    }
    // fnSetLoading(true)
    return await SearchMyCoupon({
      data: payload
    })
      .then(async (response) => {
        if (+response.data.resultCode === 20000) {
          setIsDataNotFound(false)
          let data = response.data.body
          let tmp = null
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            if (element.discountType === 'Fix') {
              element.discountText = `฿${helper.numberWithCommas(element.discount)} | ขั้นต่ำ ฿${helper.numberWithCommas(element.min)}`
            } else {
              element.discountText = `${helper.numberWithCommas(element.discount)}% | ขั้นต่ำ ฿${helper.numberWithCommas(element.min)}`
            }
            if (element.status === 'Pending') {
              const expireDate = element.qr.expireDate
              element.seconds = dayjs(expireDate).diff(new Date(), 'second')
            }
          }

          tmp = [...storeCouponList, ...data]

          if (tmp.length < response.data.totalRows) {
            let tmp = { ...loadMore }
            tmp.offset = tmp.offset + tmp.limit
            tmp.limit = 3
            setLoadmore(tmp)
            setNextPage(true)
          } else {
            setNextPage(false)
          }
          setStoreCouponList(tmp)
          setIsChangeTab(false)
          setIsChangeFilter(false)
        } else {
          setStoreCouponList([])
          setNextPage(false)
          setIsDataNotFound(true)
          setIsChangeTab(false)
          setIsChangeFilter(false)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getSearchMyCouponOnline() {
    const { offset, limit } = loadMoreOnline
    let payload = {
      memberId: memberId,
      limit: limit, offset: offset,
      sort: filterStoreCoupon,
    }
    if (amphoe) {
      payload.districtId = amphoe.amphoeId
      payload.provinceId = amphoe.provinceId
    }
    return await SearchMyCouponOnline({ data: payload })
      .then(async (response) => {
        if (+response.data.resultCode === 20000) {
          let data = response.data.body
          let tmp = null
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            if (element.status === 'Pending') {
              const expireDate = element.qr.expireDate
              element.seconds = dayjs(expireDate).diff(new Date(), 'second')
            }
          }
          tmp = [...onlineCouponList, ...data]
          if (tmp.length < response.data.totalRows) {
            let tmp = { ...loadMoreOnline }
            tmp.offset = tmp.offset + tmp.limit
            tmp.limit = 3
            setLoadMoreOnline(tmp)
            setNextPage(true)
          } else {
            setNextPage(false)
          }
          setOnlineCouponList(tmp)
          setIsChangeTab(false)
          setIsChangeFilter(false)
        } else {
          setOnlineCouponList([])
          setNextPage(false)
          setIsDataNotFound(true)
          setIsChangeTab(false)
          setIsChangeFilter(false)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getSearchCouponHistory() {
    const { offset, limit } = loadMoreHistory
    return await SearchCouponHistory({ data: { memberId: memberId, limit: limit, offset: offset } })
      .then(async (response) => {
        if (+response.data.resultCode === 20000) {
          let tmp = null
          let data = response.data.body
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            if (element.discountType === 'Fix') {
              element.discountText = `฿${helper.numberWithCommas(element.discount)} | ขั้นต่ำ ฿${helper.numberWithCommas(element.min)}`
            } else {
              element.discountText = `${helper.numberWithCommas(element.discount)}% | ขั้นต่ำ ฿${helper.numberWithCommas(element.min)}`
            }
          }
          tmp = [...historyList, ...data]
          if (tmp.length < response.data.totalRows) {
            let tmp = { ...loadMoreHistory }
            tmp.offset = tmp.offset + tmp.limit
            tmp.limit = 3
            setLoadMoreHistory(tmp)
            setNextPage(true)
          } else {
            setNextPage(false)
          }
          setHistoryList(tmp)
          setIsChangeTab(false)
          setIsChangeFilter(false)
        } else {
          setHistoryList([])
          setNextPage(false)
          setIsDataNotFound(true)
          setIsChangeTab(false)
          setIsChangeFilter(false)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setMember(tmpObj));
  }

  const fetchItems = useCallback(
    async () => {
      if (fetching) {
        return;
      }
      setFetching(true);

      try {
        if (nextPage) {
          await getSearchMyCoupon();
        }

      } finally {
        setFetching(false);
      }
    },
    [fetching, nextPage, isChangeFilter, isChangeTab]
  );

  const fetchItems2 = useCallback(
    async () => {
      if (fetching) {
        return;
      }
      setFetching(true);

      try {
        if (nextPage) {
          await getSearchMyCouponOnline();
        }
      } finally {
        setFetching(false);
      }
    },
    [fetching, nextPage, isChangeTab]
  );

  const fetchItems3 = useCallback(
    async () => {
      if (fetching) {
        return;
      }
      setFetching(true);
      try {
        if (nextPage) {
          await getSearchCouponHistory();
        }
      } finally {
        setFetching(false);
      }
    },
    [fetching, nextPage, isChangeTab]
  );

  const hasMoreItems = !!nextPage;

  const loader = (
    <div key="loader" className="loader text-center text-[20px] text-blueGray2">
      Loading ...
    </div>
  );

  async function getSearchDdlAddress2(type, search) {
    try {
      let params = {}
      if (type === txt.amphoe) {
        params.search1 = search
        if (province) {
          params.search = province.name
        }
      } else {
        params.search = search
        if (amphoe) {
          params.search1 = amphoe.name
        }
      }

      const { data } = await SearchDdlAddress2({ params: params });
      if (+data["resultCode"] === 20000) {
        const body = data.body || [];
        setProvinceList(body.provinceList)
        setAmphoeList(body.amphoeList)
      } else {
        setProvinceList([])
        setAmphoeList([])
      }
    } catch (error) {
      console.log("getSearchDdlAddress2 error", error);
    }
  }

  async function fnOnChangeAmphoe(e, value) {
    fnSetOpenAddress(txt.amphoe, false);
    fnSetOpenAddress(txt.province, false);
    setAmphoe(value);
    setAmphoeId(value.value)
    await getSearchDdlAddress2(txt.amphoe, value.name);
  }

  async function fnOnChangeProvince(e, value) {
    fnSetOpenAddress(txt.amphoe, false);
    fnSetOpenAddress(txt.province, false);
    setProvince(value);
    setProvinceId(value.value)
    await getSearchDdlAddress2(txt.province, value.name);
  }

  async function onInputChangeAddress(e, type) {
    fnSetOpenAddress(type, false);
    const value = e.target.value;
    clearTimeout(delayId);
    if (value) {
      const timeoutId = setTimeout(async () => {
        await getSearchDdlAddress2(type, value);
        fnSetOpenAddress(type, true);
      }, 500);
      setDelayId(timeoutId);
    } else {
      if (type === txt.province) {
        setProvince(null)
        setProvinceId(null)
        setProvinceList([])
      } else {
        setAmphoe(null)
        setAmphoeId(null)
        setAmphoeList([])
      }
      // fnSetOpenAddress(type, true);
    }
  }

  function fnSetOpenAddress(type, open) {
    if (type === txt.amphoe) {
      setOpenAmphoe(open);
    } else if (type === txt.province) {
      setOpenProvince(open);
    }
  }

  function fnRenderOptionAmphoe(props, option, { inputValue }) {
    const address1 = `${option.name}`;

    const matches1 = match(address1, inputValue, { insideWords: true });
    const parts1 = parse(address1, matches1);

    return (
      <li {...props} className="text-left pl-1 border-address-list">
        {/*display address*/}
        <div>
          {parts1.map((part, index) => (
            <span
              key={index}
              style={{
                fontWeight: part.highlight ? 700 : 400,
                color: part.highlight ? "#0A4197" : "#8F8F8F",
              }}
            >
              {part.text}
            </span>
          ))}
        </div>
      </li>
    );
  }

  function fnRenderOptionProvince(props, option, { inputValue }) {
    const address2 = `${option.name}`;
    const matches2 = match(address2, inputValue, { insideWords: true });
    const parts2 = parse(address2, matches2);

    return (
      <li {...props} className="text-left pl-1 border-address-list">
        {/*display address*/}
        <div>
          {parts2.map((part, index) => (
            <span
              key={index}
              style={{
                fontWeight: part.highlight ? 700 : 400,
                color: part.highlight ? "#0A4197" : "#8F8F8F",
              }}
            >
              {part.text}
            </span>
          ))}
        </div>
      </li>
    );
  }

  function fnAction(item) {
    if (item.status === 'Use') {
      fnSetData('couponId', item.id)
      fnSetData('isView', false)
      navigate("/member-coupon-detail")
      // ใช้คูปอง
    } else if (item.status === 'Wait') {
      fnSetData('couponId', item.id)
      fnSetData('isView', true)
      navigate("/member-coupon-detail")
      // postInsertCoupon(item.id)
      // เก็บคูปอง
    } else if (item.status === 'Pending') {
      fnSetData('qrCode', item.qr.qrCode)
      navigate("/member-coupon-qr-code")
    }

  }

  function fnActionOnline(item) {
    fnSetData('couponId', item.id)
    navigate("/member-coupon-online-detail")
  }

  const CountdownTimer = ({ initialSeconds }) => {
    const [seconds, setSeconds] = useState(initialSeconds);

    useEffect(() => {
      const timer = setInterval(() => {
        setSeconds((prevSeconds) => {
          const check = prevSeconds - 1
          if (check <= 0) {
            clearInterval(timer);
            setFilterStoreCoupon(1)
            setLoadmore(initialLoadMore)
            setLoadMoreOnline(initialLoadMore)
            setLoadMoreHistory(initialLoadMore)
            setNextPage(true)
            setIsDataNotFound(false)
            setStoreCouponList([])
            setIsChangeFilter(true)
          }

          return check

        });
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    }, []);

    const formatTime = (totalSeconds) => {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = parseInt(totalSeconds / 60);
      const seconds = parseInt(totalSeconds % 60);

      return <p className="text-[12px] mt-[5px] font-bold text-red">{hours.toString().padStart(2, '0')}:{minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}</p>;
    };

    return <div>{formatTime(seconds)}</div>;
  };

  function Coupon(item) {
    return (
      <div className="flex px-[10px] h-[96px] w-full mb-[20px]"
        onClick={() => {
          fnAction(item)
        }
        }
      >
        <div style={{ borderRight: "2px dashed #E8E8E8", width: "30%" }} className="relative bg-white coupon">
          {item.picture ? (
            <img style={{
              width: "80%",
              // height: "80%",
              aspectRatio: '1/1',
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }} src={item.picture} alt="" />
          ) : (
            <img style={{
              width: "85%",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }} src={coupon2} alt="" />
          )}
        </div>
        <div className="bg-white" style={{ borderRadius: "8px", width: "70%" }}>
          <div className="flex justify-between px-[10px] pt-[7px]">
            <div className="w-full">
              <div className="text-[12px] flex justify-between">
                <div className="flex">
                  <LocationOnIcon sx={{
                    color: "#00B9F1",
                    width: "13px",
                    marginTop: "-6px"
                  }} />
                  <p className="text-lightBlue">{item.shop.name}</p>
                </div>
                <p>{item.usedAmount}/{item.amount}</p>
              </div>
              <p className="text-blue text-[14px] leading-[11px]">{item.name}</p>
              <p className="text-gray text-[14px]" >ส่วนลด {item.discountText}</p>
              <div className="flex justify-between">
                {item.status === 'Pending' ? (
                  <div className="flex gap-[3px]">
                    <p className="mt-[5px] text-[12px] font-bold text-red">เหลือเวลาใช้งาน</p>
                    <CountdownTimer key={item.id} initialSeconds={item.seconds} />
                  </div>
                ) : (
                  <p className="mt-[5px] text-[12px]">ใช้คูปองได้ถึง {dayjs(item.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>
                )
                }
                {item.status === 'Use' ? (
                  <PrimaryButtonSmall className="mt-[3px] w-[73px] small-btn">ใช้ได้เลย</PrimaryButtonSmall>
                ) : item.status === 'Wait' ? (
                  <SecondaryButtonSmall className="mt-[3px] w-[73px] small-btn" variant="outlined">เก็บคูปอง</SecondaryButtonSmall>
                ) : item.status === 'Pending' ? (
                  <RedButtonSmall className="mt-[3px] w-[73px] small-btn" variant="outlined">ใช้ได้เลย</RedButtonSmall>
                ) : item.status === 'End' ? (
                  <SecondaryButtonSmall className="mt-[3px] w-[73px] small-btn" variant="outlined" disabled>เก็บคูปอง</SecondaryButtonSmall>
                ) : (
                  <SecondaryButtonSmall className="mt-[3px] w-[73px] small-btn" variant="outlined" disabled>หมดแล้ว</SecondaryButtonSmall>
                )}

              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }

  function CouponOnline(item) {
    return (
      <div className="flex px-[10px] h-[96px] w-full mt-[20px]"
        onClick={() => {
          fnActionOnline(item)
        }}>
        <div style={{ borderRight: "2px dashed #E8E8E8", width: "30%" }} className="relative bg-white coupon">
          {item.picture ? (
            <img style={{
              width: "80%",
              // height: "80%",
              aspectRatio: '1/1',
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }} src={item.picture} alt="" />
          ) : (
            <img style={{
              width: "80%",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }} src={coupon2} alt="" />
          )}

        </div>
        <div className="bg-white" style={{ borderRadius: "8px", width: "70%" }}>
          <div className="flex justify-between px-[15px] pt-[7px]">
            <div className="w-full">
              <div className="text-[12px] flex justify-between">
                <div className="flex">
                  <LocationOnIcon sx={{
                    color: "#00B9F1",
                    width: "13px",
                    marginTop: "-6px"
                  }} />
                  <p className="text-lightBlue">{item.shop.name}</p>
                </div>
              </div>
              <p className="text-blue text-[14px] leading-[11px]">{item.name}</p>
              {/* <p className="text-gray text-[14px]" >ส่วนลด ฿{helper.numberWithCommas(item.min)}</p> */}
              <div className="flex justify-between mt-[20px]">
                {item.link ? (
                  <>
                    <p className="text-[12px] mt-[4px]">ใช้คูปองได้ถึง {dayjs(item.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>
                    <PrimaryButtonSmall
                      className="mt-[3px] w-[73px] small-btn">
                      ใช้ได้เลย
                    </PrimaryButtonSmall>
                  </>
                ) : (<>
                  {item.status === 'Pending' ? (
                    <div className="flex gap-[3px] mt-[4px]">
                      <p className="text-[12px] mt-[5px] font-bold text-red">เหลือเวลาใช้งาน</p>
                      <CountdownTimer key={item.id} initialSeconds={item.seconds} />
                    </div>
                  ) : (
                    <p className="text-[12px]">ใช้คูปองได้ถึง {dayjs(item.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>
                  )
                  }
                  {item.status === 'Use' ? (
                    <PrimaryButtonSmall className="mt-[3px] w-[73px] small-btn">ใช้ได้เลย</PrimaryButtonSmall>
                  ) : item.status === 'Wait' ? (
                    <SecondaryButtonSmall className="mt-[3px] w-[73px] small-btn" variant="outlined">เก็บคูปอง</SecondaryButtonSmall>
                  ) : item.status === 'Pending' ? (
                    <RedButtonSmall className="mt-[3px] w-[73px] small-btn" variant="outlined">ใช้ได้เลย</RedButtonSmall>
                  ) : item.status === 'End' ? (
                    <SecondaryButtonSmall className="mt-[3px] w-[73px] small-btn" variant="outlined" disabled>เก็บคูปอง</SecondaryButtonSmall>
                  ) : (
                    <SecondaryButtonSmall className="mt-[3px] w-[73px] small-btn" variant="outlined" disabled>หมดแล้ว</SecondaryButtonSmall>
                  )}
                </>)}

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function CouponHistory(item) {
    return (
      <div className="flex px-[10px] h-[96px] w-full mt-[10px]">
        <div style={{ borderRight: "2px dashed #E8E8E8", width: "30%" }} className="relative bg-white coupon">
          {item.picture ? (
            <img style={{
              width: "80%",
              // height: "80%",
              aspectRatio: '1/1',
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }} src={item.picture} alt="" />
          ) : (
            <img style={{
              width: "80%",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }} src={coupon2} alt="" />
          )}

        </div>
        <div className="bg-white" style={{ borderRadius: "8px", width: "70%" }}>
          <div className="flex justify-between px-[15px] pt-[7px]">
            <div className="w-full">
              <div className="text-[12px] flex justify-between">
                <div className="flex">
                  <LocationOnIcon sx={{
                    color: "#00B9F1",
                    width: "13px",
                    marginTop: "-6px"
                  }} />
                  <p className="text-lightBlue">{item.shop.name}</p>
                </div>
              </div>
              <p className="text-blue text-[14px] leading-[11px]">{item.name}</p>
              <p className="text-gray text-[14px]">ส่วนลด {item.discountText}</p>
              <div className="flex justify-between">

                <p className="text-[12px] mt-[4px]">ใช้คูปองวันที่ {dayjs(item.usedDate, 'YYYY-MM-DD HH:m:ss').format('DD/MM/YYYY HH:m:ss')}</p>
                <div className="w-[54px] h-[23px] relative flex justify-center items-center gap-[5px] rounded-[5px]" style={{ background: 'rgba(109, 110, 113, 1)', }}>
                  <p className="text-white text-[16px]">ใช้แล้ว</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }



  return (
    <div id="shop-page">
      <TopLogo />
      <TopBanner type="memberPrivilage" />
      <Dialog open={openCookiePopup} fullWidth={true} maxWidth="xl">
        <div className="py-[24px] px-[23px] rounded-[4px]">
          <div className="float-right">
            <button onClick={() => {
              setFilterStoreCoupon(1)
              setOpenCookiePopup(false)
            }}
            ><CircleExit /></button>
          </div>
          <p className="text-[24px] font-bold text-center text-blue">กรองข้อมูลโดย</p>
          <p className="text-[20px] font-bold text-blue">จัดเรียงตาม</p>
          {isStoreCouponActive &&
            <div className="flex gap-[15px]">
              <div onClick={() => setIsSelectStoreCoupon(1)} className={isSelectStoreCoupon === 1 ? "filterSelected" : "filterUnSelected"}>
                ล่าสุด
              </div>
              <div onClick={() => setIsSelectStoreCoupon(2)} className={isSelectStoreCoupon === 2 ? "filterSelected" : "filterUnSelected"}>
                ใกล้หมดอายุ
              </div>
              <div onClick={() => setIsSelectStoreCoupon(3)} className={isSelectStoreCoupon === 3 ? "filterSelected" : "filterUnSelected"}>
                คูปองที่เก็บ
              </div>
            </div>
          }


          <p className="mt-[10px] font-bold text-[20px] text-blue">เลือกจังหวัด</p>

          <div className="grid grid-cols-2 gap-5">
            <Controller
              name="provinceId"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  freeSolo
                  disableClearable
                  onChange={fnOnChangeProvince}
                  options={provinceList}
                  open={openProvince}
                  onClose={() => fnSetOpenAddress(txt.province, false)}
                  getOptionLabel={(option) => option.name}
                  value={province}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      placeholder="จังหวัด"
                      onClick={() => fnSetOpenAddress(txt.province, !openProvince)}
                      onInput={(e) => onInputChangeAddress(e, txt.province)}
                    />
                  )}
                  renderOption={fnRenderOptionProvince}
                />
              )}
            />

            <Controller
              name="amphoeId"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  freeSolo
                  disableClearable
                  onChange={fnOnChangeAmphoe}
                  options={amphoeList}
                  open={openAmphoe}
                  onClose={() => fnSetOpenAddress(txt.amphoe, false)}
                  getOptionLabel={(option) => option.name}
                  value={amphoe}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      placeholder="เขต"
                      onClick={() => fnSetOpenAddress(txt.amphoe, !openAmphoe)}
                      onInput={(e) => onInputChangeAddress(e, txt.amphoe)}
                    />
                  )}
                  renderOption={fnRenderOptionAmphoe}
                />
              )}
            />

          </div>

          <div className="flex itesm-center gap-[13px] justify-center mt-[24px]">
            <SecondaryButton
              onClick={() => {
                setFilterStoreCoupon(1)
                setLoadmore(initialLoadMore)
                setLoadMoreOnline(initialLoadMore)
                setLoadMoreHistory(initialLoadMore)
                setNextPage(true)
                setIsDataNotFound(false)
                setOpenCookiePopup(false)
                setStoreCouponList([])
                setIsChangeFilter(true)
                setProvince(null)
                setAmphoe(null)
                setProvinceId(null)
                setAmphoeId(null)
                setProvinceList([])
                setAmphoeList([])
              }}
              variant="outlined"
              style={{ width: "40%" }}
            >
              <p className="text-[20px]">รีเซ็ต</p>
            </SecondaryButton>
            <PrimaryButton
              onClick={() => {
                console.log(province)
                console.log(provinceList)
                setFilterStoreCoupon(isSelectStoreCoupon)
                setFilterAmphoe(amphoeId)
                setFilterProvince(provinceId)
                setLoadmore(initialLoadMore)
                setLoadMoreOnline(initialLoadMore)
                setLoadMoreHistory(initialLoadMore)
                setNextPage(true)
                setIsDataNotFound(false)
                setOpenCookiePopup(false)
                setStoreCouponList([])
                setIsChangeFilter(true)
              }}
              variant="outlined"
              style={{ width: "40%" }}
            >
              <p className="text-[20px]">ยืนยัน</p>
            </PrimaryButton>
          </div>
        </div>
      </Dialog>
      <div id="shop" style={{
        // backgroundImage: `url(${background})`,
        minHeight: "220px",
        padding: "20px",
      }}
        className="bg-white px-[20px] mt-[-40px]">
        <TopBtn type="coupon"></TopBtn>

        <div className="grid grid-cols-2 px-[20px]">
          <div style={{ borderRight: "2px #0A4197 solid" }}>
            <img className="bg" style={{ margin: "auto" }} src={myCouponBtn} alt="Snow" />
            <div className="blue-line w-[74px] mt-[5px]" style={{ marginInline: "auto" }} ></div>
          </div>
          <div onClick={() => {
            navigate('/prize')
          }}>
            <img className="bg" style={{ margin: "auto" }} src={rewardBtn} alt="Snow" />
          </div>
        </div>

      </div>
      <div className="bg-lightBlue2" style={{
        height: "400px",
        minHeight: "calc(100vh - 360px)",
        height: "fit-content",
        padding: "15px",
      }}>

        <div className="grid grid-cols-3 rounded-full h-[32px] bg-white">
          <div className={isStoreCouponActive ? "rounded-full bg-lightBlue" : "rounded-full"}>
            <div className="w-fit mx-auto mt-[3%]">
              <button className={isStoreCouponActive ? "text-white" : "text-blue"}
                onClick={() => {
                  setProvince(null)
                  setAmphoe(null)
                  setProvinceId(null)
                  setAmphoeId(null)
                  setProvinceList([])
                  setAmphoeList([])
                  setIsStoreCouponActive(true)
                  setIsOnlineCouponActive(false)
                  setIsHistoryActive(false)
                  setIsChangeTab(true)
                  setFilterStoreCoupon(1)
                  setLoadmore(initialLoadMore)
                  setLoadMoreOnline(initialLoadMore)
                  setLoadMoreHistory(initialLoadMore)
                  setNextPage(true)
                  setIsDataNotFound(false)
                  setStoreCouponList([])
                  setIsChangeFilter(true)

                }}
              >คูปองร้านค้า</button>
            </div>
          </div>
          <div className={isOnlineCouponActive ? "rounded-full bg-lightBlue" : "rounded-full"}>
            <div className="w-fit mx-auto mt-[3%]">
              <button className={isOnlineCouponActive ? "text-white" : "text-blue"}
                onClick={() => {
                  setProvince(null)
                  setAmphoe(null)
                  setProvinceId(null)
                  setAmphoeId(null)
                  setProvinceList([])
                  setAmphoeList([])
                  setIsStoreCouponActive(false)
                  setIsOnlineCouponActive(true)
                  setIsHistoryActive(false)
                  setIsChangeTab(true)
                  setFilterStoreCoupon(1)
                  setLoadmore(initialLoadMore)
                  setLoadMoreOnline(initialLoadMore)
                  setLoadMoreHistory(initialLoadMore)
                  setNextPage(true)
                  setIsDataNotFound(false)
                  setOnlineCouponList([])
                  setIsChangeFilter(true)
                }}
              >คูปองออนไลน์</button>
            </div>
          </div>
          <div className={isHistoryActive ? "rounded-full bg-lightBlue" : "rounded-full"}>
            <div className="w-fit mx-auto mt-[3%]">
              <button className={isHistoryActive ? "text-white" : "text-blue"}
                onClick={() => {
                  setProvince(null)
                  setAmphoe(null)
                  setProvinceId(null)
                  setAmphoeId(null)
                  setProvinceList([])
                  setAmphoeList([])
                  setIsStoreCouponActive(false)
                  setIsOnlineCouponActive(false)
                  setIsHistoryActive(true)
                  setIsChangeTab(true)
                  setFilterStoreCoupon(1)
                  setLoadmore(initialLoadMore)
                  setLoadMoreOnline(initialLoadMore)
                  setLoadMoreHistory(initialLoadMore)
                  setNextPage(true)
                  setIsDataNotFound(false)
                  setHistoryList([])
                  setIsChangeFilter(true)
                }}
              >ประวัติการใช้งาน</button>
            </div>
          </div>
        </div >

        {isStoreCouponActive &&
          <div>
            <div className="flex justify-between mb-[10px]">
              <div className="w-full mx-[20px] my-[15px] text-white">
                <TextField
                  fullWidth
                  sx={{ input: { color: 'white' } }}
                  id="input-with-icon-textfield"
                  placeholder="Search"
                  onChange={(e) => {
                    if (timer) {
                      clearTimeout(timer);
                    }
                    if (e.target.value) {
                      timer = setTimeout(() => {
                        setLoadmore(initialLoadMore)
                        setLoadMoreOnline(initialLoadMore)
                        setLoadMoreHistory(initialLoadMore)
                        setNextPage(true)
                        setIsDataNotFound(false)
                        setFilterName(e.target.value)
                        setStoreCouponList([])
                        setIsChangeFilter(true)
                      }, 1000);
                    } else {
                      setLoadmore(initialLoadMore)
                      setLoadMoreOnline(initialLoadMore)
                      setLoadMoreHistory(initialLoadMore)
                      setNextPage(true)
                      setIsDataNotFound(false)
                      setFilterName(e.target.value)
                      setStoreCouponList([])
                      setIsChangeFilter(true)
                    }

                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search sx={{
                          color: "white",
                          width: "15px"
                        }} />
                      </InputAdornment>
                    ),
                  }}
                  variant="standard"
                />
              </div>
              <button
                className="mr-[15px] mt-[15px] w-[67px] h-[32px] flex gap-[5px] items-center justify-center py-[1px] px-[20px] rounded-[5px] border-[1px] border-white"
                onClick={() => {
                  // setAmphoe(null)
                  // setProvince(null)
                  // setAmphoeList([])
                  // setProvinceList([])
                  setIsSelectStoreCoupon(filterStoreCoupon)
                  setOpenCookiePopup(true)
                }
                }
              >
                <FilterListIcon sx={{
                  color: "white",
                  width: "15px"
                }} />
                <p className="text-white text-[20px]">Filter</p>
              </button>
            </div>

            {isStoreCouponActive && !isDataNotFound &&
              <>
                <InfiniteScroll
                  loadMore={fetchItems}
                  hasMore={hasMoreItems}
                  loader={loader}
                  useWindow={true}
                >
                  {storeCouponList.map((item, index) => (
                    <div key={index}>
                      {Coupon(item)}
                    </div>
                  ))}
                </InfiniteScroll>
              </>
            }


            {isStoreCouponActive && isDataNotFound &&
              <div className="mt-[50px]">
                <img className="mx-auto w-[200px] opacity-30" src={coupon1} alt="Snow" />
                <div className="mt-[30px] text-center">
                  <p className="mx-auto text-[14px]" style={{ color: 'rgba(230, 231, 232, 1)' }}>
                    ยังไม่มีคูปอง
                  </p>
                </div>
                <div className="mb-[50px] text-center">
                  <p className="mx-auto text-[14px]" style={{ color: 'rgba(230, 231, 232, 1)' }}>
                    คุณสามารถรับคูปองได้ที่ร้านค้าที่ร่วมกิจกรรม
                  </p>
                </div>
              </div>
            }
          </div>
        }

        {isOnlineCouponActive &&
          <div className="mt-[10px]">
            {isOnlineCouponActive && !isDataNotFound &&
              <InfiniteScroll
                loadMore={fetchItems2}
                hasMore={hasMoreItems}
                loader={loader}
                useWindow={true}
              >
                {onlineCouponList.map((item, index) => (
                  <div key={index}>
                    {CouponOnline(item)}
                  </div>
                ))}
              </InfiniteScroll>
            }


            {isOnlineCouponActive && isDataNotFound &&
              <div className="mt-[50px]">
                <img className="mx-auto w-[200px] opacity-30" src={coupon1} alt="Snow" />
                <div className="mt-[30px] text-center">
                  <p className="mx-auto text-[14px]" style={{ color: 'rgba(230, 231, 232, 1)' }}>
                    ยังไม่มีคูปอง
                  </p>
                </div>
                <div className="mb-[50px] text-center">
                  <p className="mx-auto text-[14px]" style={{ color: 'rgba(230, 231, 232, 1)' }}>
                    คุณสามารถรับคูปองได้ที่ร้านค้าที่ร่วมกิจกรรม
                  </p>
                </div>
              </div>
            }
          </div>
        }

        {isHistoryActive &&
          <div>
            {isHistoryActive && !isDataNotFound &&
              <>
                <p className="mt-[10px] text-center" style={{ color: 'rgba(230, 231, 232, 1)' }}>แสดงย้อนหลัง 30 วันเท่านั้น</p>
                <InfiniteScroll
                  loadMore={fetchItems3}
                  hasMore={hasMoreItems}
                  loader={loader}
                  useWindow={true}
                >
                  {historyList.map((item, index) => (
                    <div key={index}>
                      {CouponHistory(item)}
                    </div>
                  ))}
                </InfiniteScroll>
              </>
            }

            {isHistoryActive && isDataNotFound &&
              <div className="my-[50px]">
                <img className="mx-auto w-[200px] opacity-30" src={coupon1} alt="Snow" />
                <div className="mt-[30px] text-center">
                  <p className="mx-auto text-[14px]" style={{ color: 'rgba(230, 231, 232, 1)' }}>
                    ยังไม่มีประวัติการใช้คูปอง
                  </p>
                </div>
              </div>
            }
          </div>
        }
      </div>
      {/* <>
        <TopLogo />
        <div
          style={{
            background: `url(${backgroundSuccess}) no-repeat center center fixed`,
            minHeight: "calc(100vh - 60px)",
            backgroundSize: "cover",
            paddingTop: "25px",
            paddingBottom: "25px"
          }}
        ></div>
        <div className="leading-[34px] text-[34px] no-event text-white text-center">
          <p className="mb-[200px]">
             ติดตามกิจกรรมใหม่ๆ <br></br> ของ Haier Privilege <br></br> ผ่านทาง Social media  <br></br> ของเราได้เลยครับ 
            พบกันเร็ว ๆ นี้
          </p>
          <TransparentButton
            className="w-[80%]"
            variant="outlined"
            onClick={() => liff.closeWindow()}
          >
            <p>ย้อนกลับ</p>
          </TransparentButton>
        </div>

      </> */}
    </div >
    // <>
    //   <TopLogo />
    //   <div
    //     style={{
    //       background: `url(${backgroundSuccess}) no-repeat center center fixed`,
    //       minHeight: "calc(100vh - 60px)",
    //       backgroundSize: "cover",
    //       paddingTop: "25px",
    //       paddingBottom: "25px"
    //     }}
    //   >
    //     <div className="leading-[34px] text-[34px] no-event text-white text-center">
    //       <p className="mb-[200px]">
    //         พบกันเร็ว ๆ นี้
    //       </p>
    //       <TransparentButton
    //         className="w-[80%]"
    //         variant="outlined"
    //         onClick={() => liff.closeWindow()}
    //       >
    //         <p>ย้อนกลับ</p>
    //       </TransparentButton>
    //     </div>

    //   </div>
    // </>
  )
}